import React from "react";
// import arrayDestructss from "../assets/arrayDestructss.jpg";
// import installNode from "../assets/installNode.jpg";
// import reactParallax from "../assets/reactParallax.jpg";
// import reactSmooth from "../assets/reactSmooth.jpg";
// import navbar from "../assets/navbar.jpg";
import Weather7 from "../assets/Weather7.jpg";
import Enthub from "../assets/Enthub.jpg";
import merngrocery from "../assets/merngrocery.png";
import workout from "../assets/workout.png";
import youtube from "../assets/youtube.png";
const Portfolio = () => {
  // const portfolios = [
  //   {
  //     id: 1,
  //     src: Weather7,
  //     href: "https://manuwhatistemperature.netlify.app/",
  //     code: "https://github.com/Manu6677/Weather-app-manu",
  //   },
  //   {
  //     id: 2,
  //     src: Enthub,
  //     href: "https://manutrendingshows.netlify.app/",
  //     code: "https://github.com/Manu6677/EHub",
  //   },
  // ];

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from from-black to bg-gray-800
       text-white w-full md:h-screen"
    >
      <div
        className="max-w-screen-lg p-4 mx-auto flex flex-col
      justify-center w-full h-full"
      >
        <div className="pb-8">
          <p className="text-4xl inline border-b-4 border-gray-500 font-bold">
            Portfolio
          </p>
          <p className="py-6 font-semibold">
            Check out some of my work right here.
          </p>
        </div>

        {/* structure of whole card */}

        <div className="grid sm:grid-cols-3 gap-8 px-12 sm:px-0">
          {/* Project Num-1 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={Weather7}
              alt=""
              className="rounded-lg
             hover:scale-110 duration-300"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://manuwhatistemperature.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Live
                </button>
              </a>

              <a
                href="https://github.com/Manu6677/Weather-app-manu"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Github
                </button>
              </a>
            </div>
          </div>
          {/* till here */}

          {/* Project Num-2 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={merngrocery}
              alt="noImg"
              className="rounded-lg
             hover:scale-110 duration-300 h-44"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://grocery-app-fawn.vercel.app"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Live
                </button>
              </a>

              <a
                href="https://github.com/Manu6677/mernapp"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Github
                </button>
              </a>
            </div>
          </div>

          {/* Project Num-3 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={workout}
              alt=""
              className="rounded-lg
             hover:scale-110 duration-300 h-44"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://workoutbuddies.netlify.app"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Live
                </button>
              </a>

              <a
                href="https://github.com/Manu6677/mernapp"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Github
                </button>
              </a>
            </div>
          </div>

          {/* Project Num-4 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={youtube}
              alt=""
              className="rounded-lg
             hover:scale-110 duration-300 h-44"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://namasteyoutube.netlify.app"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Live
                </button>
              </a>

              <a
                href="https://github.com/Manu6677/Namaste-Youtube"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Github
                </button>
              </a>
            </div>
          </div>

          {/* Project Num-5 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={Enthub}
              alt=""
              className="rounded-lg
             hover:scale-110 duration-00"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://manutrendingshows.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Live
                </button>
              </a>

              <a
                href="https://github.com/Manu6677/EHub"
                target="_blank"
                rel="noreferrer"
              >
                <button className="w/2 px-6 py-4 hover:scale-105 duration-200">
                  Github
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
